import React from 'react';
import {useIntl} from 'react-intl';

import {useSearchMgrInstance} from 'coreHooks';

import Button from 'brandComponents/Button';

import {ILoadMoreProps} from './ILoadMoreButton';
import messages from './messages';

import styles from './LoadMoreButton.module.scss';

const LoadMoreButton = ({
	direction,
	searchInstanceKey,
	searchType
}: ILoadMoreProps) => {
	const intl = useIntl();
	const searchMgr = useSearchMgrInstance({
		searchType,
		key: searchInstanceKey
	});

	return (
		<div className={styles['load-more-btn__wrapper']}>
			<Button
				classNames={styles['load-more_btn']}
				variant="primary-white"
				onClick={() => {
					if (searchMgr.loadPage(direction)) {
						searchMgr.search();
					}
				}}
			>
				{intl.formatMessage(messages.cta)}
			</Button>
		</div>
	);
};

export default LoadMoreButton;
